var render = function render(_c,_vm){return _c('div',{staticClass:"inline-flex justify-center items-center flex-shrink-0 ml-2 w-6 h-6 rounded-full bg-red-300 text-white text-sm"},[_vm._v("\n  !\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }